import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrowth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGrowth"><Path d="M12 12V10.5C12 6.63401 8.86599 3.5 5 3.5H3.5V5C3.5 8.86599 6.63401 12 10.5 12H12ZM12 12V20.5M19 6.5H20.5V8C20.5 11.866 17.366 15 13.5 15H12V13.5C12 9.63401 15.134 6.5 19 6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGrowth;
